<ng-template #crmAge>
    <div class="block-text">{{ "CRM.AGE" | translate }}: <span class="mr-1" [ngStyle]="{ color: crmUtilsService.getWarningColor(crmNoteService.getLastNoteTime(crmItem))}">{{crmNoteService.getLastNoteTime(crmItem) | crmAge}}</span> ({{ crmItem.lastStatusTimestamp | crmAge:true }})</div>
</ng-template>
<ng-template #crmSilenceUntil>
    <div class="block-text">{{ "CRM.SILENCED_UNTIL" | translate }}: <span>{{silenceUntilVal}}</span></div>
</ng-template>

<div class="crm-item-details-parent">
    <div class="crm-item-details-content-parent px-3" (click)="isOpen = !isOpen;">
        <div class="mx-2">
            <i class="fa fa-2x caret" [ngClass]="isOpen ? 'fa-angle-up' : 'fa-angle-down'"></i>
        </div>
        <div class="crm-item-details-content border-right w-50">
            <div class="crm-item-details-content-block margin-right">
                <div class="block-text d-flex flex-row align-items-center">
                    <div class="mr-1">{{ "CRM.NAME" | translate }}:</div>
                    <span *ngIf="crmView">{{crmItem.name}}</span>
                    <a *ngIf="!crmView" [routerLink]="CRM_ITEM_ROUTE + crmItem.id" target="_blank">{{crmItem.name}}</a>
                    <rms-crm-archive-timer  class="ml-2" [crmItem]="crmItem"></rms-crm-archive-timer>
                </div>
                <div *ngIf="crmUtilsService.isCrmProject(crmItem)" class="block-text" >{{ "CRM.STATUS" | translate }}: <span>{{statusLabels[crmItem.status]}}</span></div>
                <ng-container *ngIf="crmUtilsService.isCrmProject(crmItem)"><ng-container *ngTemplateOutlet="crmAge"></ng-container></ng-container>
                <ng-container *ngIf="crmUtilsService.isCrmProject(crmItem)"><ng-container *ngTemplateOutlet="crmSilenceUntil"></ng-container></ng-container>
                <div *ngIf="!crmUtilsService.isCrmProject(crmItem) && crmView" class="block-text">{{ "GENERICS.COMPANY" | translate }}: <span><a [routerLink]="COMPANY_ROUTE + crmItem.companies[0]?.company?.id" target="_blank">{{crmItem.companies[0]?.company?.name}}</a></span></div>
                <div *ngIf="!crmUtilsService.isCrmProject(crmItem)" class="block-text">{{ "CRM.STORM" | translate }}: <span>{{stormLabels[crmItem.companies[0]?.storm]}}</span></div>
                <div *ngIf="!crmUtilsService.isCrmProject(crmItem)" class="block-text">{{ "CRM.COURTSHIP" | translate }}: <span>{{crmItem.companies[0]?.company?.courtshipType ? courtshipLabels[crmItem.companies[0].company.courtshipType] : 'None'}}</span>
                    <div class="d-inline-block ml-1">
                        <rms-courtship-selector
                            [readOnly]="true"
                            [companyId]="crmItem.companies[0]?.company.id"
                            [courtship]="crmItem.companies[0]?.company.courtshipType"
                            >
                        </rms-courtship-selector>
                    </div>
                </div>
            </div>
            <div class="crm-item-details-content-block mw-50">
                <div *ngIf="crmUtilsService.isCrmProject(crmItem)" class="block-text">{{ "CRM.PROJECT_TOPIC" | translate }}: <span>{{crmItem.description}}</span></div>
                <ng-container *ngIf="!crmUtilsService.isCrmProject(crmItem)"><ng-container *ngTemplateOutlet="crmAge"></ng-container></ng-container>
                <div *ngIf="!crmUtilsService.isCrmProject(crmItem)" class="block-text">{{ "CRM.ETAKI" | translate | uppercase }}: <span>{{crmItem.companies[0]?.etaki  && crmStatusService.hasEtakiStatus(crmItem) ? crmItem.companies[0]?.etaki : '-'}}</span></div>
                <ng-container *ngIf="!crmUtilsService.isCrmProject(crmItem)"><ng-container *ngTemplateOutlet="crmSilenceUntil"></ng-container></ng-container>
            </div>
        </div>
        <div class="crm-item-details-content">
            <div class="crm-item-details-content-block">
                <div class="block-text">{{ "CRM.DOMAIN" | translate }}: <span>{{crmItem.domains[0]?.name}}</span></div>
                <div class="d-flex flex-row align-space-between">
                    <div class="block-text mr-1">{{ "CRM.DILIGENCE_LEAD" | translate }}: <span>{{crmItem.leader?.user?.fullName ? crmItem.leader.user.fullName : '-'}}</span></div>
                    <div class="block-text ml-1">{{ "CRM.TRIAGE_OWNER" | translate }}: <span>{{crmItem.triageOwner?.user?.fullName ? crmItem.triageOwner.user.fullName : '-'}}</span></div>
                </div>
                <div class="block-text">{{ "CRM.PARTICIPANTS" | translate }}: <span>{{getParticipants()}}</span></div>
            </div>
        </div>
        <div class="crm-item-details-content d-flex justify-content-end">
            <div *ngIf="!crmUtilsService.isCrmProject(crmItem)" class="crm-item-stage">
                <rms-bubble-timeline [currentStageOnly]="true" [currentStage]="crmStatusService.getCurrentStage(crmItem)" [stages]="crmStatusService.getStages(crmItem)" [rejected]="crmStatusService.isRejected(crmItem)" [vertical]="belowBreakpoint()"></rms-bubble-timeline>
            </div>
        </div>
        <div class="crm-item-details-content ml-auto">
            <div class="crm-item-details-content-block">
                <div *ngIf="crmView && !crmItem.archived" class="crm-item-details-content-block-buttons ml-2">
                    <i class="fa fa-pencil" (click)="editCrmItem()"></i>
                    <div class="btn archive-button" (click)="openArchiveModal()">{{ "CRM.ARCHIVE_MODAL.ARCHIVE" | translate }}</div>
                </div>
                <div *ngIf="!crmView && !crmItem.archived" class="crm-item-details-content-block-buttons ml-2">
                    <i (click)="openCrmHistory(crmItem); $event.stopPropagation()" class="fa fa-history pull-right crm-history-button"></i>
                    <i class="fa fa-pencil" (click)="editCrmItem()"></i>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="isOpen" class="crm-item-details-display">
        <div *ngIf="!crmUtilsService.isCrmProject(crmItem)" class="crm-item-details-timeline">
            <rms-bubble-timeline [currentStageOnly]="false" [currentStage]="crmStatusService.getCurrentStage(crmItem)" [stages]="crmStatusService.getStages(crmItem)" [rejected]="crmStatusService.isRejected(crmItem)" [vertical]="belowBreakpoint()"></rms-bubble-timeline>
        </div>
        <div *ngIf="crmUtilsService.isCrmProject(crmItem)">
            <rms-crm-references-panel [crmItem]="crmItem"></rms-crm-references-panel>
        </div>
        <div *ngIf="!crmView && archivedItems?.length > 0" class="crm-item-details-archived">
            <mat-expansion-panel [expanded]="false" [hideToggle]="true" (opened)="showArchived()" (closed)="hideArchived()">
                <mat-expansion-panel-header [expandedHeight]="'fit-content'" [collapsedHeight]="'fit-content'">
                    <div class="crm-item-details-archived-header">
                        Closed Sonar Records: <i [ngClass]="archivedOpen ? 'fa fa-angle-down' : 'fa fa-angle-up'"></i>
                    </div>
                </mat-expansion-panel-header>
                <div>
                    <table class="w-100 table table-striped">
                        <thead>
                        <td>{{ "CRM.NAME" | translate }}</td>
                        <td>{{ "CRM.CREATED_DATE" | translate }}</td>
                        <td>{{ "CRM.STATUS" | translate }}</td>
                        <td>{{ "CRM.ETAKI" | translate | uppercase }}</td>
                        <td>{{ "CRM.DILIGENCE_LEAD" | translate }}</td>
                        <td>{{ "CRM.DOMAIN" | translate }}</td>
                        <td>{{ "CRM.Note" | translate }} #</td>
                        </thead>
                        <tbody>
                        <ng-container *ngFor="let item of archivedItems | rmsSortBy:'created'; let i=index;">
                            <tr>
                                <td><span (click)="showSingleCrmNote(item)">{{item.name}}</span></td>
                                <td>{{getDate(item)}}</td>
                                <td>{{statusLabels[item.status]}}</td>
                                <td>{{crmItem.companies[0]?.etaki  && crmStatusService.hasEtakiStatus(crmItem) ? crmItem.companies[0]?.etaki : '-'}}</td>
                                <td>{{item.leader.user.fullName}}</td>
                                <td>{{item.domains[0].name}}</td>
                                <td>{{item.notes.length}}</td>
                            </tr>
                        </ng-container>
                        </tbody>
                    </table>
                </div>
            </mat-expansion-panel>
        </div>
    </div>
</div>
